import React from "react";
import Button from "lib/common/descriptorcontrols/BaseControls/Button";
import PropTypes from "prop-types";
import classnames from "classnames";

function SplitButton({
                         actions,
                         type,
                         className,
                         disabled,
                         ...passthrough
                     }) {
    const dropdownAnchorRef = React.useRef();

    function handleSelect(e, ignored, action) {
        e.preventDefault();
        action && action.onSelect && action.onSelect();
    }

    return <div
        className={classnames("btn-group", "split-button", className)}
        ref={dropdownAnchorRef}
    >
        <Button
            {...passthrough}
            enabled={!disabled}
            icon={actions[0].icon}
            onClick={handleSelect}
            className={classnames("btn", `btn-${type}`, {
                ["primary-" + className]: !!className,
            })}
            label={actions[0].label}
            value={actions[0]}
        />
        <Button
            enabled={!disabled}
            onClick={handleSelect}
            className={classnames("btn", `btn-${type}`, {
                ["split-" + className]: !!className,
            })}
            options={actions}
            anchorRef={dropdownAnchorRef}
        />
    </div>;
}

SplitButton.propTypes = {
    type: PropTypes.string,
    className: PropTypes.string,
    actions: PropTypes.arrayOf(
        PropTypes.shape({
            label: PropTypes.node.isRequired,
            value: PropTypes.any.isRequired,
            onSelect: PropTypes.func.isRequired,
        })
    ).isRequired,
    disabled: PropTypes.bool,
};

SplitButton.defaultProps = {
    type: "default",
};

export default SplitButton;



// WEBPACK FOOTER //
// ./app/lib/common/components/SplitButton.js